<div class="modal show">
	<div class="modal__content">
		<app-loader *ngIf="isLoading"></app-loader>
		<div *ngIf="!isLoading" class="modal__content__body">
			<div class="body__header">
				<h2>{{ roaming.translations[languageService.getLanguage() ?? 'es']?.title }}</h2>
				<span>{{ roaming.translations[languageService.getLanguage() ?? 'es']?.subtitle }}</span>
			</div>
			<div *ngIf="!(accessibilityService.accessibility$ | async)" class="collapse-group">
				<ng-container *ngFor="let detail of roaming.translations[languageService.getLanguage() ?? 'es']?.details">
					<div
						class="collapse"
						[ngClass]="{ 'collapse--expanded': detailIdSelected === detail.product_detail_id }"
						(click)="detailIdSelected = detailIdSelected === detail.product_detail_id ? -1 : detail.product_detail_id"
					>
						<div class="collapse__header">
							<div class="collapse__header__title">
								<div class="title__text">
									<h5>{{ detail.title }}</h5>
									<p *ngIf="detail.subtitle">{{ detail.subtitle }}</p>
								</div>
							</div>
							<i class="icon-triangle-down"></i>
						</div>
						<div [innerHTML]="detail.description" class="collapse__body"></div>
					</div>
				</ng-container>
			</div>
			<div *ngIf="accessibilityService.accessibility$ | async" class="collapse-carousel">
				<div class="collapse-group">
					<ng-container
						*ngFor="let detail of roaming.translations[languageService.getLanguage() ?? 'es']?.details; let i = index"
					>
						<div class="collapse" [ngClass]="{ show: indexSelected === i }">
							<div class="collapse__header">
								<div class="collapse__header__title">
									<i class="icon--sm" [ngClass]="'icon-' + detail.icon"></i>
									<div class="title__text">
										<h5>{{ detail.title }}</h5>
										<span>{{ detail.subtitle }}</span>
									</div>
								</div>
							</div>
							<div [innerHTML]="detail.description" class="collapse__body"></div>
						</div>
					</ng-container>
				</div>
				<div class="collapse-carousel__pagination">
					<button class="button-icon" (click)="subtract()">
						<i class="icon-arrow-left"></i>
					</button>
					<span
						>{{ indexSelected + 1 }}/{{
							this.roaming.translations[this.languageService.getLanguage() ?? 'es']?.details.length
						}}</span
					>
					<button class="button-icon" (click)="add()">
						<i class="icon-arrow-right"></i>
					</button>
				</div>
			</div>
		</div>
		<div class="modal__content__buttons">
			<app-button icon="icon-chevron-left" label=" {{ 'GENERAL.BACK' | translate }}" (click)="dialogRef.close()">
			</app-button>
		</div>
	</div>
</div>
